import React from "react";
import { useState,useEffect } from "react";
import userService from "../../app/services/user.service";
import { useLocation,useNavigate } from "react-router-dom";
import { Breadcrumb, Col, Row, Form, Button } from 'react-bootstrap';
import Toast from "../../UI/Toast/Toast";
import { ChevronRight } from '@mui/icons-material';
import Loader from '../../UI/loader/loader';
import { Link } from "react-router-dom";



export const HomeworkList=()=>{
    
    
    const [homeworkQuestionList,setHomeworkQuestionList]=useState([]);
   

    const location = useLocation();
    const { schedule_id } = location.state || {};
    // console.log(schedule_id);

    useEffect(()=>{

        getHomeworkQuestionList();
   
       },[])


    const getHomeworkQuestionList=()=>{

        userService.homeworkQuestionList(schedule_id)
      .then(res => {
        setHomeworkQuestionList(res.data.data);
        console.log("Data",res.data.data);

      })
      .catch(err => {
        console.error('Failed to fetch homework modules', err);
      });
    }
  console.log(homeworkQuestionList);

  

    return(
        <>
         <Toast />
            <div className="d-flex page-head justify-content-between align-items-center">
                <div>
                    <h4> Homework Details</h4>
                    <Breadcrumb>
                        <Breadcrumb.Item active>Homework Details</Breadcrumb.Item>
                        <Breadcrumb.Item active>viewQuestion</Breadcrumb.Item>
                        {/* <Breadcrumb.Item active>Completed</Breadcrumb.Item>
            <Breadcrumb.Item active>Questions</Breadcrumb.Item> */}
                    </Breadcrumb>
                </div>
            </div>
        
           <div>

            {homeworkQuestionList.length>0 ? " ":<Loader />}
           
           {
            homeworkQuestionList?.map((question,index)=>(
            <div className="preview-card1 preview-card">
                <div>
                    <p><b>{question.dropdown_list}</b></p>
                    <span className="preview-text">Total Questions: {question.total_questions}</span>

                </div>
          <Link 
            to="./ViewQuestions" 
            state={{ schedule_id: schedule_id, module_id: question.id }}
          >
            <ChevronRight className="preview-icon" />
          </Link>
            </div>
              
             )) }
             </div>
        

        </>
    )
}